import { c as _c } from "react/compiler-runtime";
import Script from "next/script";
export default function LinkedInInsightTag() {
  const $ = _c(3);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Script id="linkedin-insight-tag" strategy="afterInteractive">{"\n          _linkedin_partner_id = \"8153186\";\n          window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];\n          window._linkedin_data_partner_ids.push(_linkedin_partner_id);\n        "}</Script>;
    t1 = <Script id="linkedin-insight-tag-script" strategy="afterInteractive">{"\n          (function(l) {\n            if (!l){window.lintrk = function(a,b){window.lintrk.q.push([a,b])};\n            window.lintrk.q=[]}\n            var s = document.getElementsByTagName(\"script\")[0];\n            var b = document.createElement(\"script\");\n            b.type = \"text/javascript\";b.async = true;\n            b.src = \"https://snap.licdn.com/li.lms-analytics/insight.min.js\";\n            s.parentNode.insertBefore(b, s);})(window.lintrk);\n        "}</Script>;
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <>{t0}{t1}<noscript><img height="1" width="1" style={{
          display: "none"
        }} alt="" src="https://px.ads.linkedin.com/collect/?pid=8153186&fmt=gif" /></noscript></>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}